import type { WritableComputedRef } from 'vue'
// import { BEHAVIOR } from "~/api/module/rights"
import { ORDER_BEHAVIOR, USER_LEVEL_KEY, type UserInfo } from '~/api/interface'
import type { ISO4217 } from '~/constants/locale'
import { useTime } from '~/hooks/useTime'

export function getBehavior(
  currentLevel: USER_LEVEL_KEY,
  selectLevel: USER_LEVEL_KEY
) {
  const behaviorMap = {
    [USER_LEVEL_KEY.TASTE + USER_LEVEL_KEY.PERSONAL]: ORDER_BEHAVIOR.BUY, // 当前试用，选择个人
    [USER_LEVEL_KEY.TASTE + USER_LEVEL_KEY.PERSONAL_LITE]: ORDER_BEHAVIOR.BUY, // 当前试用，选择个人
    [USER_LEVEL_KEY.PERSONAL + USER_LEVEL_KEY.PERSONAL]: ORDER_BEHAVIOR.RENEW, // 当前个人
    [USER_LEVEL_KEY.PERSONAL_LITE + USER_LEVEL_KEY.PERSONAL_LITE]:
      ORDER_BEHAVIOR.RENEW, // 当前个人
    [USER_LEVEL_KEY.ORG_STANDARD + USER_LEVEL_KEY.ORG_STANDARD]:
      ORDER_BEHAVIOR.RENEW, // 当前企业基础，选择企业基础
    [USER_LEVEL_KEY.ORG_STANDARD + USER_LEVEL_KEY.ORG_FLAGSHIP]:
      ORDER_BEHAVIOR.UPGRADE, // 当前企业基础，选择企业旗舰
    [USER_LEVEL_KEY.ORG_FLAGSHIP + USER_LEVEL_KEY.ORG_FLAGSHIP]:
      ORDER_BEHAVIOR.RENEW, // 当前企业旗舰，选择企业旗舰
  }
  return behaviorMap[currentLevel + selectLevel]
}

export function calcExpireDate(userInfo?: UserInfo, days?: number) {
  const { $dayjs } = useTime()
  // const userInfo = useUserInfo()
  if (!userInfo) {
    return '错误的用户信息'
  }
  const { personal_expired_time } = userInfo
  let start = $dayjs()
  if (personal_expired_time) {
    // is_expire 定为 true
    start = $dayjs(personal_expired_time)
  }
  return start.add(days || 0, 'days').format('YYYY/MM/DD')
}

// 分 -> 元 & 增加前缀
export function formatPrice(fen: number, locales?: ISO4217) {
  const runtime = useRuntimeConfig() as any
  let prefix = isGlobalVersion() ? '$' : '¥'
  if (runtime.public.area === 'HK') {
    prefix = 'HK$'
  }
  if (locales) {
    switch (locales) {
      case 'CNY':
        prefix = '¥'
        break
      case 'HKD':
        prefix = 'HK$'
        break
      default:
        prefix = '$'
    }
  }

  const v = (fen / 100).toFixed(2)
  if (v.split('.')[1] === '00') {
    return {
      prefix,
      value: Math.floor(+v),
      string: prefix + Math.floor(+v),
    }
  }
  return { prefix, value: +v, string: prefix + v }
}

type Key =
  | 'current_total_credit_coin'
  | 'current_remained_credit_coin'
  | 'account_total_credit_coin'
  | 'account_remained_credit_coin'
  | 'current_buy_more_total_credit_coin'
  | 'current_buy_more_remained_credit_coin'
  | 'account_buy_more_total_credit_coin'
  | 'account_buy_more_remained_credit_coin'
  | 'free_account_total_credit_coin'
  | 'free_account_remained_credit_coin'
  | 'packet_total_buy_more_credit_coin'
  | 'packet_used_buy_more_credit_coin'

// 获取言币相关值
export function bindUserInfo(
  userInfo: WritableComputedRef<UserInfo | undefined>
) {
  return function getNumber(key: Key, _default?: number) {
    if (_default !== undefined) {
      return _default
    }
    if (userInfo.value) {
      return userInfo.value[key] || 0
    }
    return 0
  }
}
